'use strict';
const $ = require('jquery');
window.$ = $;
window.jQuery = $;

import './css/styles.scss';
require('bootstrap');
import 'bootstrap-select';

import { mobileNavigation, toc, cookiesBar } from './js/modules'
import adminMenu from '@elasticms/admin-menu';
import back2top from "./js/back2top";
import ajaxSearch from "./js/ajax-search";
import externalLink from "./js/external-link";
import form from "./js/form";
import contentWysiwyg from './js/content-wysiwyg';
import responsive from './js/responsive';
// import searchFilters from './js/search-filters';
import searchBar from './js/search-bar';
import error404 from './js/error-404';
// import {NavBar} from "./js/navbar";


const translations = JSON.parse(document.body.getAttribute('data-translations'));

adminMenu('esm_demo_admin', '<i class="ems-icon"></i><span class="sr-only">'+ (translations.back_to_ems === undefined ? 'Back to ems' : translations.back_to_ems) + '</span>');
back2top();
ajaxSearch();
externalLink('<span class="sr-only">'+ (translations.target_blank === undefined ? 'Back to ems' : translations.target_blank) + '</span>');
form();
contentWysiwyg();
// searchFilters();
searchBar();
responsive();
error404();

// JAWS FIX FOR BOOTSTRAP SELECT
$(document).on('keydown', '.bootstrap-select .dropdown-toggle', function(e) {
    if (e.keyCode === 13 || e.keyCode === 32) {
        $('.selectpicker').selectpicker('toggle');
    }
});

$(window).on('load', function() {
    $('.dropdown-menu[role="presentation"]').removeAttr('role');
});

mobileNavigation.init('.js-change-location')
toc.init({ selector: '.js-toc', contentSelector: '.js-toc-parsing h2' });
cookiesBar.init('.js-cookies-bar');

// const navBar = new NavBar();
// navBar.activateBestItem();
